import { createStyles } from '@material-ui/core';

import logo from '~assets/images/ULSticker.svg';
import { maskImageStyles } from '~utils/styles';

export const styles = () =>
  createStyles({
    wrapper: {
      textAlign: 'center',
      fontWeight: 'bold',
    },

    logo: {
      margin: '16px auto !important',
      display: 'block',
      background: '#BE0F34',
      maskPosition: 'center',
      maskRepeat: 'no-repeat',
      maskSize: 'contain',
      width: 110,
      height: 46,
      ...maskImageStyles(logo),

      '&.collapsed': {
        width: '50px !important',
        height: '36px !important',
        ...maskImageStyles(logo),
      },
    },

  });
